import React, { useEffect } from "react";
import { Box } from "@material-ui/core";
import Typography from "@mui/material/Typography";
import Markdown from "react-markdown";

type HintBoxProps = {
  id: any;
  hints: any;
};

const HintsBox = ({ id, hints }: HintBoxProps) => {
  // const hintText = `Consequat mauris nunc congue nisi vitae suscipit. Fringilla est
  // ullamcorper eget nulla facilisi etiam dignissim diam. Pulvinar elementum
  // integer enim neque volutpat ac tincidunt. Ornare suspendisse sed nisi
  // lacus sed viverra tellus. Purus sit amet volutpat consequat mauris.
  // Elementum eu facilisis sed odio morbi. Euismod lacinia at quis risus sed
  // vulputate odio. Morbi tincidunt ornare massa eget egestas purus viverra
  // accumsan in. In hendrerit gravida rutrum quisque non tellus orci ac.
  // Pellentesque nec nam aliquam sem et tortor. Habitant morbi tristique
  // senectus et. Adipiscing elit duis tristique sollicitudin nibh sit.
  // Ornare aenean euismod elementum nisi quis eleifend. Commodo viverra
  // maecenas accumsan lacus vel facilisis. Nulla posuere sollicitudin
  // aliquam ultrices sagittis orci a.`;
  console.log("hints", hints);

  // const hints = [
  //   {
  //     id: 0,
  //     hint: hintText,
  //   },
  //   {
  //     id: 1,
  //     hint: hintText,
  //   },
  //   {
  //     id: 2,
  //     hint: hintText,
  //   },
  // ];

  const displayHints = hints
    .map((hint: any, index: number) => {
      return { id: index, content: hint?.content };
    })
    .slice(0, id);

  return (
    <Box style={{ margin: "30px" }}>
      {displayHints.map((hint: any) => {
        return (
          <>
            <Typography variant="h5" gutterBottom>
              Hint: {hint?.id + 1}
            </Typography>
            <Typography
              variant="body1"
              sx={{ color: "#000000", fontSize: "1.2rem" }}
            >
              <Markdown>{hint?.content}</Markdown>
            </Typography>
            {/* <Typography sx={{ marginBottom: 2 }}>{}</Typography> */}
          </>
        );
      })}
    </Box>
    // <Box style={{ margin: "30px" }}>
    //   {displayHints.map((hint: any) => {
    //     <Typography variant="h5" gutterBottom>
    //       {`Hint -  ${hint?.id + 1}`}
    //     </Typography>;
    //     {
    //       hint?.content ? (
    //         <Markdown>{hint?.content}</Markdown>
    //       ) : (
    //         <Typography sx={{ marginBottom: 2 }}>
    //           {"No Hints available"}
    //         </Typography>
    //       );
    //     }
    //   })}
    // </Box>
  );
};

export default HintsBox;
